import { memo } from "react";

import { observer } from "mobx-react-lite";
import { Link, useLocation } from "react-router-dom";

import iplus from "../../assets/images/100-add-white.svg";
import { useMeetingDetailsStore } from "../../contexts/meetingDetails/meetingDetailsContext";
import { useUserMedia } from "../../hooks/useUserMedia";
import { CurrentMeetingActionsAndDetails } from "../lw-widget/current-meeting-actions-and-details";
import { UsersCameraAndControls } from "../lw-widget/users-camera-and-controls";

const MainTopBar = () => {
  const location = useLocation();
  const { meeting } = useMeetingDetailsStore();
  const { previewCamStream } = useUserMedia();

  return (
    <>
      <div className="flex">
        <div className="align-items-center SH1-SemiBold text-nowrap page-header-data">Live Workspaces</div>
        {location.pathname === "/live" && (
          <Link to="/live/create">
            <div className="button button-lg button-bk button-r m-l-32">
              <img alt="" src={iplus} /> Create New
            </div>
          </Link>
        )}
      </div>

      {meeting?.status === "started" && previewCamStream && (
        <div className="live-workspace-widget-wrap">
          <UsersCameraAndControls />
          <div className="divider-vertical current-meeting-status-bar-list-users" />
          <CurrentMeetingActionsAndDetails />
        </div>
      )}
    </>
  );
};
export default memo(observer(MainTopBar));
